// FILE: src/Components/Dashboard.js (FULLY UPDATED)

import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import OnboardingChecklist from './Dashboard/OnboardingChecklist';
import SignalsFeed from './Dashboard/SignalsFeed';
import Calender from './Calender';
import QueuePage from './QueuePage';
import PublishPage from './PublishPage';
import MediaLibrary from './Assets/MediaLibrary';
import BrandKit from './BrandKit';
import GroupsProfile from './GroupsProfile';
import AccountSetting from './AccountSetting';
import CreateCampagin from './CreateCampagin';
import Inbox from './Inbox';
import Message from './Message';
import Competitor from './Competitor';
import PostReport from './PostReport';
import ProfileReports from './ProfileReports';
import Konvatest from './Konvatest';
import LinksDashboard from './Publishing/LinksDashboard'; // <-- ADD THIS NEW IMPORT

// This new component defines the content of the main dashboard page
const DashboardContent = () => (
    <div className="p-4 sm:p-6 lg:p-8">
        <Header />
        <OnboardingChecklist />
        <SignalsFeed />
    </div>
);

export default function Dashboard() {
  return (
    <div className="flex h-screen bg-gray-50">
      <div className="w-64 flex-shrink-0">
        <Sidebar />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 overflow-y-auto">
          <Routes>
            {/* The main dashboard route now renders DashboardContent */}
            <Route path="/" element={<DashboardContent />} />
            
            {/* All other nested routes for the dashboard area */}
            <Route path='/Publishing' element={<Calender />} />
            <Route path="/QueuePage" element={<QueuePage />} />
            <Route path="/PublishPost" element={<PublishPage />} />
            <Route path="/Links" element={<LinksDashboard />} /> {/* <-- ADD THIS NEW ROUTE */}
            <Route path="/Assets" element={<MediaLibrary />} />
            <Route path="/BrandKit" element={<BrandKit />} /> 
            <Route path="/GroupsProfile" element={<GroupsProfile />} />
            <Route path="/AccountSetting" element={<AccountSetting />} />
            <Route path="/Reports" element={<ProfileReports />} />
            <Route path="/Inbox" element={<Inbox />} />
            <Route path="/Campagin" element={<CreateCampagin />} />
            <Route path="/Message" element={<Message />} />
            <Route path="/Competitor" element={<Competitor />} />
            <Route path="/Postreports" element={<PostReport />} />
            <Route path='/Konva' element={<Konvatest />} />
            
            {/* A fallback to redirect any unknown dashboard URL back to the main dashboard */}
            <Route path="*" element={<Navigate to="/Dashboard" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}